import { isLoggedUserGlobalEditor, getUser } from '~src/user';
import { getMetadata } from '~loader/loader-utils';
import { getState } from '../../state';
import { onAddQuoteToCanvas } from './onAddQuoteToCanvas';
import { getCategoryFromEvent } from './getCategoryFromEvent';
import { filterQuotes } from './filterQuotes';
import $ from 'jquery';

export const displaySidebarQuotes = async () => {
  const isGlobalEditor = await isLoggedUserGlobalEditor();
  const { user } = await getUser();

  const metadata = getMetadata();

  const defaultCategory = getCategoryFromEvent({
    event: metadata.templatesCategoryName,
    project: metadata.projectTypeName,
    availableCategories: Object.keys(window.editorConfig.sidebarQuotes.items),
  });

  const currentCategory = getState(
    'sidebarCurrentQuotesCategory',
    defaultCategory
  );

  const quotes = window.editorConfig.sidebarQuotes.items[currentCategory];

  let quoteNumeber = 0;

  if (!quotes) {
    const html =
      '<div class="text-center mt-5 mb-4">Nessun testo inserito</div>';
    $('#tab-quotes .items-container-grid-quotes').html(html);
    return;
  }
  const { ids, html } = quotes?.reduce(
    (acc, item) => {
      quoteNumeber++;
      let isUserOwner;
      if (item.org_pointer) {
        if (user.org_pointer.objectId === item.org_pointer.objectId) {
          isUserOwner = true;
        }
      }

      const itemId = `editor-sidebar-add-quotes-${item.objectId}`;
      acc.html += `
              <div
                  class="editor-sidebar-item-container editor-sidebar-quotes-container">
                  <div class="editor-sidebar-quote-box" id="${itemId}" data-text="${item.testo}">
                      <p class="number-block">${quoteNumeber}</p>
                      <p class="text-block">&lsaquo;&lsaquo;${item.testo}&rsaquo;&rsaquo;</p>
                  </div>`;
      if (isGlobalEditor || isUserOwner) {
        acc.html += `<div
                      id="editor-sidebar-sub-menu-${item.objectId}"
                    class="editor-sidebar-item-sub-menu-container-quote editor-sidebar-item-page">
                    <button
                      class="btn btn-sidebar-quotes-delete buttonSidebarDanger"
                      data-quote-id="${item.objectId}"> Elimina
                    </button>
                  </div>`;
      }
      acc.html += '</div>';

      acc.ids.push(`#${itemId}`);

      return acc;
    },
    { ids: [], html: '' }
  );

  $('#tab-quotes .items-container-grid-quotes').html(html);

  const filter = $('#input-filter-quotes').val().toLowerCase();
  filterQuotes(filter);

  if (ids.length) {
    ids.forEach((id) => {
      $('body').off('click', id, onAddQuoteToCanvas);
      $('body').on('click', id, onAddQuoteToCanvas);
    });
  }
};
